export default __webpack_public_path__ + "static/media/title_vi_sp.e4671c84.png";